import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './supplement-categories.reducer';

export const SupplementCategoriesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const supplementCategoriesEntity = useAppSelector(state => state.supplementCategories.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="supplementCategoriesDetailsHeading">
          <Translate contentKey="fitengineerBackendV2App.supplementCategories.detail.title">SupplementCategories</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{supplementCategoriesEntity.id}</dd>
          <dt>
            <span id="category">
              <Translate contentKey="fitengineerBackendV2App.supplementCategories.category">Category</Translate>
            </span>
          </dt>
          <dd>{supplementCategoriesEntity.category}</dd>
        </dl>
        <Button tag={Link} to="/supplement-categories" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/supplement-categories/${supplementCategoriesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SupplementCategoriesDetail;
